function Icon(props) {
  const { type, width, height, onClick, color, strokeWidth, className } = props;
  switch (type) {
    case "hire-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 94 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="94.0001" height="36.0486" rx="6.75911" fill="#F2F8FE" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.67344 0C2.9878 0 0 2.9878 0 6.67344V29.3751C0 33.0608 2.98781 36.0486 6.67344 36.0486H87.3267C91.0123 36.0486 94.0001 33.0608 94.0001 29.3751V6.67344C94.0001 2.9878 91.0123 0 87.3267 0H6.67344ZM45.2335 27.5865C46.459 28.6652 48.1181 29.2046 50.2109 29.2046C51.2667 29.2046 52.1999 29.0866 53.0106 28.8506C53.8402 28.5978 54.5283 28.286 55.0751 27.9152C55.6218 27.5444 56.0366 27.1652 56.3194 26.7775C56.6211 26.3899 56.7813 26.0612 56.8002 25.7915C56.819 25.6398 56.7625 25.5134 56.6305 25.4123C56.5174 25.3112 56.3666 25.2606 56.178 25.2606H53.7459C53.5385 25.2606 53.3783 25.2859 53.2651 25.3365C53.1709 25.3702 53.0389 25.4881 52.8692 25.6904C52.7749 25.8084 52.6147 25.9601 52.3885 26.1455C52.1622 26.3309 51.87 26.4994 51.5118 26.6511C51.1535 26.7859 50.7105 26.8534 50.1826 26.8534C49.5416 26.8534 48.9854 26.7017 48.514 26.3983C48.0616 26.0949 47.7128 25.6988 47.4677 25.21C47.2414 24.7044 47.1189 24.1566 47.1 23.5667V23.4403V23.3645H56.4891C56.6965 23.3645 56.8662 23.3055 56.9981 23.1875C57.1301 23.0695 57.1961 22.9263 57.1961 22.7577V22.2268C57.1961 20.9122 56.9322 19.7576 56.4043 18.7632C55.8764 17.7519 55.0939 16.9682 54.057 16.412C53.02 15.839 51.738 15.5524 50.2109 15.5524C48.8345 15.5524 47.6373 15.8053 46.6192 16.3109C45.6012 16.7997 44.7999 17.5076 44.2154 18.4345C43.6498 19.3447 43.3293 20.4402 43.2539 21.7212C43.235 21.8729 43.2256 22.0835 43.2256 22.3532C43.2256 22.606 43.235 22.8167 43.2539 22.9853C43.3481 24.9741 44.008 26.5078 45.2335 27.5865ZM53.35 21.2408H47.1V21.165C47.1 20.5077 47.2131 19.9346 47.4394 19.4458C47.6845 18.9402 48.0427 18.5525 48.514 18.2829C48.9854 17.9963 49.551 17.8531 50.2109 17.8531C50.8707 17.8531 51.4363 17.9963 51.9077 18.2829C52.379 18.5525 52.7372 18.9402 52.9823 19.4458C53.2274 19.9346 53.35 20.5077 53.35 21.165V21.2408ZM33.1502 29.0276C33.2822 29.1456 33.4424 29.2046 33.631 29.2046H36.0913C36.2987 29.2046 36.4684 29.1456 36.6004 29.0276C36.7324 28.9096 36.7984 28.7663 36.7984 28.5978V21.6453C36.7984 20.8363 37.0434 20.2127 37.5336 19.7745C38.0427 19.3194 38.7497 19.0919 39.6547 19.0919H41.8605C42.0679 19.0919 42.2282 19.0329 42.3413 18.9149C42.4733 18.7969 42.5393 18.6537 42.5393 18.4851V16.6648C42.5393 16.4963 42.4733 16.353 42.3413 16.235C42.2282 16.1171 42.0679 16.0581 41.8605 16.0581H40.701C39.7961 16.0581 38.9948 16.2013 38.2972 16.4879C37.6185 16.7744 37.0623 17.1873 36.6287 17.7267V16.6901C36.6287 16.5047 36.5533 16.353 36.4024 16.235C36.2705 16.1171 36.1102 16.0581 35.9217 16.0581H33.631C33.4424 16.0581 33.2822 16.1171 33.1502 16.235C33.0182 16.353 32.9522 16.5047 32.9522 16.6901V28.5978C32.9522 28.7663 33.0182 28.9096 33.1502 29.0276ZM65.2735 27.9027C65.1028 27.9027 64.9576 27.8484 64.8381 27.74C64.7186 27.6315 64.6589 27.4998 64.6589 27.3448V23.1578H60.0873C59.9166 23.1578 59.7715 23.1036 59.652 22.9951C59.5325 22.8866 59.4727 22.7472 59.4727 22.5767V20.6773C59.4727 20.5069 59.5325 20.3752 59.652 20.2822C59.7715 20.1737 59.9166 20.1195 60.0873 20.1195H64.6589V16.0487C64.6589 15.8937 64.7186 15.762 64.8381 15.6535C64.9576 15.5451 65.1028 15.4908 65.2735 15.4908H67.4495C67.6373 15.4908 67.7825 15.5451 67.8849 15.6535C68.0044 15.762 68.0642 15.8937 68.0642 16.0487V20.1195H72.6357C72.8064 20.1195 72.9516 20.1737 73.0711 20.2822C73.1906 20.3752 73.2503 20.5069 73.2503 20.6773V22.5767C73.2503 22.7472 73.1906 22.8866 73.0711 22.9951C72.9516 23.1036 72.8064 23.1578 72.6357 23.1578H68.0642V27.3448C68.0642 27.4998 68.0044 27.6315 67.8849 27.74C67.7825 27.8484 67.6373 27.9027 67.4495 27.9027H65.2735ZM81.3082 27.9027C81.1375 27.9027 80.9923 27.8484 80.8728 27.74C80.7533 27.6315 80.6936 27.4998 80.6936 27.3448V23.1578H76.122C75.9513 23.1578 75.8062 23.1036 75.6867 22.9951C75.5672 22.8866 75.5074 22.7472 75.5074 22.5767V20.6773C75.5074 20.5069 75.5672 20.3752 75.6867 20.2822C75.8062 20.1737 75.9513 20.1195 76.122 20.1195H80.6936V16.0487C80.6936 15.8937 80.7533 15.762 80.8728 15.6535C80.9923 15.5451 81.1375 15.4908 81.3082 15.4908H83.4843C83.6721 15.4908 83.8172 15.5451 83.9196 15.6535C84.0391 15.762 84.0989 15.8937 84.0989 16.0487V20.1195H88.6704C88.8411 20.1195 88.9863 20.1737 89.1058 20.2822C89.2253 20.3752 89.285 20.5069 89.285 20.6773V22.5767C89.285 22.7472 89.2253 22.8866 89.1058 22.9951C88.9863 23.1036 88.8411 23.1578 88.6704 23.1578H84.0989V27.3448C84.0989 27.4998 84.0391 27.6315 83.9196 27.74C83.8172 27.8484 83.6721 27.9027 83.4843 27.9027H81.3082ZM28.6292 15.5632C29.9074 15.5632 30.9436 14.448 30.9436 13.0724C30.9436 11.6968 29.9074 10.5817 28.6292 10.5817C27.351 10.5817 26.3148 11.6968 26.3148 13.0724C26.3148 14.448 27.351 15.5632 28.6292 15.5632ZM27.4704 29.2493C27.2832 29.2493 27.1241 29.185 26.993 29.0566C26.9442 29.0087 26.8374 28.957 26.7227 28.9014C26.5299 28.808 26.3148 28.7038 26.3148 28.5888L26.6842 17.1134C26.6842 16.9636 26.7278 16.9238 26.8152 16.8444C26.8348 16.8266 26.8567 16.8067 26.8807 16.7831C27.0118 16.6547 27.0866 16.6455 27.2738 16.6455H29.8291C30.035 16.6455 30.2222 16.6547 30.3345 16.7831C30.4656 16.9116 30.4749 16.9299 30.4749 17.1134L30.9436 28.5888C30.9436 28.7042 30.7321 28.8088 30.5426 28.9025C30.4309 28.9576 30.327 29.009 30.2784 29.0566C30.1661 29.185 30.0069 29.2493 29.801 29.2493H27.4704ZM7.18933 11.6738C8.46756 11.6738 9.50376 10.5586 9.50376 9.18304C9.50376 7.80745 8.46756 6.69231 7.18933 6.69231C5.91111 6.69231 4.8749 7.80745 4.8749 9.18304C4.8749 10.5586 5.91111 11.6738 7.18933 11.6738ZM24.3157 9.7199C24.3157 11.0955 23.2795 12.2106 22.0013 12.2106C20.7231 12.2106 19.6869 11.0955 19.6869 9.7199C19.6869 8.3443 20.7231 7.22916 22.0013 7.22916C23.2795 7.22916 24.3157 8.3443 24.3157 9.7199ZM9.08582 29.2558H5.74642C5.71336 29.2558 5.62078 29.2378 5.51498 29.1658C5.38273 29.0758 4.98598 28.6856 4.88679 28.4456C4.85431 28.367 4.89274 26.9248 4.94946 24.7957C5.03132 21.7234 5.15128 17.2207 5.15128 13.3211L5.25047 13.1111L5.34966 12.961L5.51498 12.841L5.74642 12.7209H9.05275L9.31726 12.781L9.44951 12.871L9.61483 13.051L9.68095 13.1111L9.74708 13.3211C9.74708 13.3211 10.0328 15.5718 9.96665 16.5321C9.90052 17.4923 19.5007 17.8525 19.5007 17.8525L19.4346 13.3211L19.5338 13.1411L19.633 12.991L19.7983 12.841L19.9967 12.7509L20.2612 12.7209H23.303L23.5345 12.7509L23.6998 12.841L23.8651 12.961L23.9974 13.1411L24.0635 13.3211L24.328 28.2355L24.1957 28.6556L23.9974 28.8957L23.8982 29.0157L23.6998 29.1658L23.5345 29.2258L23.4022 29.2558H20.2281L20.0628 29.2258L19.8975 29.1658L19.7653 29.0758L19.633 28.9557L19.5669 28.8357L19.3354 28.6556L19.2032 28.2355L19.5007 20.4932C15.5985 19.582 13.4582 19.5469 9.74708 20.4932C9.74708 22.087 9.78841 23.2782 9.82974 24.4694C9.87107 25.6606 9.9124 26.8518 9.9124 28.4456L9.71402 28.7757L9.64789 28.8957L9.5487 29.0157L9.44951 29.1358L9.31726 29.1958L9.11888 29.2558H9.08582Z"
            fill="#2888F6"
          />
        </svg>
      );
    case "email-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6667 3.9974C14.6667 3.26406 14.0667 2.66406 13.3334 2.66406H2.66671C1.93337 2.66406 1.33337 3.26406 1.33337 3.9974M14.6667 3.9974V11.9974C14.6667 12.7307 14.0667 13.3307 13.3334 13.3307H2.66671C1.93337 13.3307 1.33337 12.7307 1.33337 11.9974V3.9974M14.6667 3.9974L8.00004 8.66406L1.33337 3.9974"
            stroke={color ? color : "white"}
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "clock":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.17285 3.8V8L10.9729 9.4M15.1729 8C15.1729 11.866 12.0388 15 8.17285 15C4.30686 15 1.17285 11.866 1.17285 8C1.17285 4.13401 4.30686 1 8.17285 1C12.0388 1 15.1729 4.13401 15.1729 8Z"
            stroke={color}
            stroke-width="1.3271"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "video-logo":
      return (
        <svg
          width="16"
          height="19"
          viewBox="0 0 16 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.51755 17.7336H10.8423M14.3999 8.64188C14.3999 12.3532 11.3913 15.3619 7.6799 15.3619C3.96855 15.3619 0.9599 12.3532 0.9599 8.64188C0.9599 4.93052 3.96855 1.92188 7.6799 1.92188C11.3913 1.92188 14.3999 4.93052 14.3999 8.64188ZM10.1999 8.64188C10.1999 10.0336 9.07166 11.1619 7.6799 11.1619C6.28814 11.1619 5.1599 10.0336 5.1599 8.64188C5.1599 7.25012 6.28814 6.12188 7.6799 6.12188C9.07166 6.12188 10.1999 7.25012 10.1999 8.64188Z"
            stroke="#101828"
            stroke-width="1.92"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "audio-logo":
      return (
        <svg
          width="18"
          height="14"
          viewBox="0 0 18 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5904 1.74838C15.6789 3.26152 16.32 5.11808 16.32 7.12438C16.32 9.13068 15.6789 10.9872 14.5904 12.5004M11.5164 4.05238C12.1238 4.92317 12.48 5.98217 12.48 7.12438C12.48 8.26659 12.1238 9.3256 11.5164 10.1964M6.82318 2.02923L4.39193 4.46047C4.2591 4.5933 4.19269 4.65971 4.11518 4.70721C4.04647 4.74932 3.97156 4.78035 3.89319 4.79916C3.8048 4.82038 3.71088 4.82038 3.52304 4.82038H2.18882C1.7587 4.82038 1.54364 4.82038 1.37936 4.90409C1.23485 4.97772 1.11736 5.09521 1.04373 5.23972C0.960022 5.404 0.960022 5.61906 0.960022 6.04918V8.19958C0.960022 8.6297 0.960022 8.84476 1.04373 9.00905C1.11736 9.15355 1.23485 9.27104 1.37936 9.34467C1.54364 9.42838 1.7587 9.42838 2.18882 9.42838H3.52304C3.71088 9.42838 3.8048 9.42838 3.89319 9.4496C3.97156 9.46842 4.04647 9.49945 4.11518 9.54155C4.19269 9.58905 4.2591 9.65546 4.39193 9.78829L6.82318 12.2195C7.15217 12.5485 7.31667 12.713 7.45789 12.7241C7.58044 12.7338 7.70019 12.6842 7.78002 12.5907C7.87202 12.483 7.87202 12.2504 7.87202 11.7851V2.46367C7.87202 1.99841 7.87202 1.76577 7.78002 1.65805C7.70019 1.56458 7.58044 1.51498 7.45789 1.52462C7.31667 1.53574 7.15217 1.70023 6.82318 2.02923Z"
            stroke="#101828"
            stroke-width="1.92"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "type-logo":
      return (
        <svg
          width="18"
          height="17"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.40802 4.31419H3.41762C2.55738 4.31419 2.12726 4.31419 1.79869 4.4816C1.50968 4.62886 1.2747 4.86384 1.12744 5.15286C0.960022 5.48143 0.960022 5.91155 0.960022 6.77179V9.53659C0.960022 10.3968 0.960022 10.8269 1.12744 11.1555C1.2747 11.4445 1.50968 11.6795 1.79869 11.8268C2.12726 11.9942 2.55738 11.9942 3.41762 11.9942H9.40802M12.48 4.31419H13.8624C14.7227 4.31419 15.1528 4.31419 15.4814 4.4816C15.7704 4.62886 16.0053 4.86384 16.1526 5.15286C16.32 5.48143 16.32 5.91155 16.32 6.77179V9.53659C16.32 10.3968 16.32 10.8269 16.1526 11.1555C16.0053 11.4445 15.7704 11.6795 15.4814 11.8268C15.1528 11.9942 14.7227 11.9942 13.8624 11.9942H12.48M12.48 15.0662L12.48 1.24219M14.4 1.24219L10.56 1.24219M14.4 15.0662L10.56 15.0662"
            stroke="#101828"
            stroke-width="1.92"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "screenshare-logo":
      return (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.75913 17.9334C8.78426 17.4417 9.93884 17.1654 11.16 17.1654C12.3811 17.1654 13.5357 17.4417 14.5608 17.9334M7.16638 14.8614H15.1536C16.4439 14.8614 17.0891 14.8614 17.582 14.6103C18.0155 14.3894 18.368 14.0369 18.5889 13.6034C18.84 13.1105 18.84 12.4653 18.84 11.175V7.79577C18.84 6.50541 18.84 5.86023 18.5889 5.36738C18.368 4.93386 18.0155 4.58139 17.582 4.3605C17.0891 4.10938 16.4439 4.10938 15.1536 4.10938H7.16638C5.87602 4.10938 5.23084 4.10938 4.73799 4.3605C4.30446 4.58139 3.95199 4.93386 3.7311 5.36738C3.47998 5.86023 3.47998 6.50541 3.47998 7.79578V11.175C3.47998 12.4653 3.47998 13.1105 3.7311 13.6034C3.95199 14.0369 4.30446 14.3894 4.73799 14.6103C5.23084 14.8614 5.87602 14.8614 7.16638 14.8614Z"
            stroke="#101828"
            stroke-width="1.92"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "download-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 11.5H1M9.33333 5.94444L6 9.27778M6 9.27778L2.66667 5.94444M6 9.27778V1.5"
            stroke={color || "#475467"}
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "overAll-analysis-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 10 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.46745 5.39531H2.66745M3.60078 7.26198H2.66745M6.40078 3.52865H2.66745M8.26745 5.16198V3.43531C8.26745 2.65124 8.26745 2.2592 8.11486 1.95973C7.98063 1.6963 7.76646 1.48213 7.50303 1.3479C7.20356 1.19531 6.81152 1.19531 6.02745 1.19531H3.04078C2.25671 1.19531 1.86467 1.19531 1.56519 1.3479C1.30177 1.48213 1.08759 1.6963 0.953372 1.95973C0.800781 2.2592 0.800781 2.65124 0.800781 3.43531V8.28865C0.800781 9.07272 0.800781 9.46476 0.953372 9.76423C1.08759 10.0277 1.30177 10.2418 1.56519 10.3761C1.86467 10.5286 2.25671 10.5286 3.04078 10.5286H4.30078M9.20078 10.5286L8.50078 9.82865M8.96745 8.66198C8.96745 9.56404 8.23618 10.2953 7.33411 10.2953C6.43205 10.2953 5.70078 9.56404 5.70078 8.66198C5.70078 7.75991 6.43205 7.02865 7.33411 7.02865C8.23618 7.02865 8.96745 7.75991 8.96745 8.66198Z"
            stroke="#F2F8FE"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "skill-analysis-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 12 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0113 10.1427V6.45847M5.80078 10.1427V4.87952M1.59026 10.1427L1.59025 8.03742M6.54114 2.26242L9.26137 3.28251M5.16856 2.45896L2.22195 4.66891M10.5695 3.00549C10.8779 3.3138 10.8779 3.81367 10.5695 4.12198C10.2612 4.43028 9.76137 4.43028 9.45307 4.12198C9.14476 3.81367 9.14476 3.3138 9.45307 3.00549C9.76137 2.69718 10.2612 2.69718 10.5695 3.00549ZM2.1485 4.58444C2.45681 4.89275 2.45681 5.39261 2.1485 5.70092C1.84019 6.00923 1.34032 6.00923 1.03201 5.70092C0.723704 5.39261 0.723704 4.89275 1.03201 4.58444C1.34032 4.27613 1.84019 4.27613 2.1485 4.58444ZM6.35902 1.42654C6.66733 1.73485 6.66733 2.23472 6.35902 2.54303C6.05072 2.85134 5.55085 2.85134 5.24254 2.54303C4.93423 2.23472 4.93423 1.73485 5.24254 1.42654C5.55085 1.11824 6.05072 1.11824 6.35902 1.42654Z"
            stroke="#F2F8FE"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "video-analysis-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 14 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 3.35882C13 2.99533 13 2.81359 12.9281 2.72943C12.8658 2.65641 12.7722 2.61765 12.6765 2.62519C12.5661 2.63387 12.4376 2.76239 12.1806 3.01941L10 5.2L12.1806 7.38059C12.4376 7.63761 12.5661 7.76613 12.6765 7.77481C12.7722 7.78235 12.8658 7.74359 12.9281 7.67057C13 7.58641 13 7.40467 13 7.04118V3.35882Z"
            stroke="#F2F8FE"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1 3.88C1 2.87191 1 2.36786 1.19619 1.98282C1.36876 1.64413 1.64413 1.36876 1.98282 1.19619C2.36786 1 2.87191 1 3.88 1H7.12C8.12809 1 8.63214 1 9.01718 1.19619C9.35588 1.36876 9.63124 1.64413 9.80381 1.98282C10 2.36786 10 2.87191 10 3.88V6.52C10 7.52809 10 8.03214 9.80381 8.41718C9.63124 8.75587 9.35588 9.03124 9.01718 9.20381C8.63214 9.4 8.12809 9.4 7.12 9.4H3.88C2.87191 9.4 2.36786 9.4 1.98282 9.20381C1.64413 9.03124 1.36876 8.75587 1.19619 8.41718C1 8.03214 1 7.52809 1 6.52V3.88Z"
            stroke="#F2F8FE"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "integrity-analysis-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.125 6.895L5.375 8.145L8.1875 5.3325M11 7.2075C11 10.2753 7.65377 12.5065 6.43624 13.2168C6.29787 13.2975 6.22869 13.3379 6.13105 13.3588C6.05528 13.3751 5.94472 13.3751 5.86895 13.3588C5.77131 13.3379 5.70213 13.2975 5.56376 13.2168C4.34623 12.5065 1 10.2753 1 7.2075V4.2185C1 3.71881 1 3.46896 1.08173 3.25419C1.15392 3.06446 1.27124 2.89517 1.42354 2.76096C1.59593 2.60902 1.82987 2.5213 2.29775 2.34584L5.64888 1.08917C5.77881 1.04045 5.84378 1.01608 5.91061 1.00642C5.9699 0.997858 6.0301 0.997858 6.08938 1.00642C6.15622 1.01608 6.22119 1.04045 6.35112 1.08917L9.70225 2.34584C10.1701 2.5213 10.4041 2.60902 10.5765 2.76096C10.7288 2.89517 10.8461 3.06446 10.9183 3.25419C11 3.46896 11 3.71881 11 4.2185V7.2075Z"
            stroke="#F2F8FE"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "action-analysis-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 12 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4118 7.17647V3.82353C10.4118 2.8352 10.4118 2.34104 10.2194 1.96355C10.0502 1.6315 9.78027 1.36153 9.44822 1.19234C9.07073 1 8.57656 1 7.58824 1H3.82353C2.8352 1 2.34104 1 1.96355 1.19234C1.6315 1.36153 1.36153 1.6315 1.19234 1.96355C1 2.34104 1 2.8352 1 3.82353V9.94118C1 10.9295 1 11.4237 1.19234 11.8012C1.36153 12.1332 1.6315 12.4032 1.96355 12.5724C2.34104 12.7647 2.8352 12.7647 3.82353 12.7647H5.70588M6.88235 6.29412H3.35294M4.52941 8.64706H3.35294M8.05882 3.94118H3.35294M7.17647 11L8.35294 12.1765L11 9.52941"
            stroke="#F2F8FE"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "skill-edit-modal-icon":
      return (
        <svg
          width="20"
          height="24"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 11.37L12.3333 12.0993C11.9797 12.486 11.5001 12.7033 11.0001 12.7033C10.5001 12.7033 10.0205 12.486 9.66693 12.0993C9.31282 11.7134 8.83333 11.4967 8.33346 11.4967C7.8336 11.4967 7.3541 11.7134 6.99999 12.0993M1 12.7033H2.11636C2.44248 12.7033 2.60555 12.7033 2.759 12.6665C2.89504 12.6338 3.0251 12.5799 3.1444 12.5068C3.27896 12.4244 3.39426 12.3091 3.62486 12.0785L12 3.70328C12.5523 3.15099 12.5523 2.25556 12 1.70328C11.4477 1.15099 10.5523 1.15099 10 1.70328L1.62484 10.0784C1.39424 10.3091 1.27894 10.4244 1.19648 10.5589C1.12338 10.6782 1.0695 10.8083 1.03684 10.9443C1 11.0978 1 11.2608 1 11.5869V12.7033Z"
            stroke="#98A2B3"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "video-edit-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 11 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1439_13320)">
            <path
              d="M5.38838 10.39C7.81741 10.39 9.78653 8.42093 9.78653 5.9919C9.78653 3.56287 7.81741 1.59375 5.38838 1.59375C2.95935 1.59375 0.990234 3.56287 0.990234 5.9919C0.990234 8.42093 2.95935 10.39 5.38838 10.39Z"
              stroke="white"
              stroke-width="0.881389"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.50875 4.23264L7.14764 5.9919L4.50875 7.75116V4.23264Z"
              stroke="white"
              stroke-width="0.881389"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1439_13320">
              <rect
                width="10.5556"
                height="10.5556"
                fill="white"
                transform="translate(0.111328 0.71875)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "head-orientation-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 19.5C17 18.1044 17 17.4067 16.8278 16.8389C16.44 15.5605 15.4395 14.56 14.1611 14.1722C13.5933 14 12.8956 14 11.5 14H6.5C5.10444 14 4.40665 14 3.83886 14.1722C2.56045 14.56 1.56004 15.5605 1.17224 16.8389C1 17.4067 1 18.1044 1 19.5M13.5 6C13.5 8.48528 11.4853 10.5 9 10.5C6.51472 10.5 4.5 8.48528 4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6Z"
            stroke="#F2F8FE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "pupil-orientation-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 22 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.57637 8.71318C1.44019 8.49754 1.37209 8.38972 1.33397 8.22342C1.30534 8.0985 1.30534 7.9015 1.33397 7.77658C1.37209 7.61028 1.44019 7.50246 1.57637 7.28682C2.70178 5.50484 6.05165 1 11.1567 1C16.2617 1 19.6115 5.50484 20.7369 7.28682C20.8731 7.50246 20.9412 7.61028 20.9793 7.77658C21.008 7.9015 21.008 8.0985 20.9793 8.22342C20.9412 8.38972 20.8731 8.49754 20.7369 8.71318C19.6115 10.4952 16.2617 15 11.1567 15C6.05165 15 2.70178 10.4952 1.57637 8.71318Z"
            stroke="#F2F8FE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.1567 11C12.8135 11 14.1567 9.65685 14.1567 8C14.1567 6.34315 12.8135 5 11.1567 5C9.4998 5 8.15665 6.34315 8.15665 8C8.15665 9.65685 9.4998 11 11.1567 11Z"
            stroke="#F2F8FE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "dominant-orientation-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 13C7 13 8.5 15 11 15C13.5 15 15 13 15 13M14 8H14.01M8 8H8.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11ZM14.5 8C14.5 8.27614 14.2761 8.5 14 8.5C13.7239 8.5 13.5 8.27614 13.5 8C13.5 7.72386 13.7239 7.5 14 7.5C14.2761 7.5 14.5 7.72386 14.5 8ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z"
            stroke="#F2F8FE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "lock-orientation-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 44 58"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M38.2506 19.2708H35.5423V13.8542C35.5423 6.37917 29.4757 0.3125 22.0007 0.3125C14.5257 0.3125 8.45898 6.37917 8.45898 13.8542V19.2708H5.75065C2.75794 19.2708 0.333984 21.6948 0.333984 24.6875V51.7708C0.333984 54.7635 2.75794 57.1875 5.75065 57.1875H38.2506C41.2434 57.1875 43.6673 54.7635 43.6673 51.7708V24.6875C43.6673 21.6948 41.2434 19.2708 38.2506 19.2708ZM22.0007 43.6458C19.0079 43.6458 16.584 41.2219 16.584 38.2292C16.584 35.2365 19.0079 32.8125 22.0007 32.8125C24.9934 32.8125 27.4173 35.2365 27.4173 38.2292C27.4173 41.2219 24.9934 43.6458 22.0007 43.6458ZM30.3965 19.2708H13.6048V13.8542C13.6048 9.22292 17.3694 5.45833 22.0007 5.45833C26.6319 5.45833 30.3965 9.22292 30.3965 13.8542V19.2708Z"
            fill="#98A2B3"
          />
        </svg>
      );
    case "report-transcript-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.22222 4.07899H6M3.22222 6.02344H7.66667M4.71319 9.35677H8.33333C9.26675 9.35677 9.73346 9.35677 10.09 9.17512C10.4036 9.01533 10.6586 8.76036 10.8183 8.44676C11 8.09024 11 7.62353 11 6.6901V3.6901C11 2.75668 11 2.28997 10.8183 1.93345C10.6586 1.61985 10.4036 1.36488 10.09 1.20509C9.73346 1.02344 9.26675 1.02344 8.33333 1.02344H3.66667C2.73325 1.02344 2.26654 1.02344 1.91002 1.20509C1.59641 1.36488 1.34144 1.61985 1.18166 1.93345C1 2.28997 1 2.75668 1 3.6901V10.6543C1 10.9503 1 11.0983 1.06068 11.1743C1.11346 11.2404 1.19348 11.2789 1.27808 11.2788C1.37535 11.2787 1.49093 11.1863 1.72209 11.0013L3.04734 9.94112C3.31807 9.72454 3.45343 9.61625 3.60416 9.53924C3.73789 9.47092 3.88024 9.42099 4.02734 9.3908C4.19315 9.35677 4.3665 9.35677 4.71319 9.35677Z"
            stroke="#F2F8FE"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "report-eye-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 17 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5227 6.36296C3.45353 6.25343 3.41894 6.19867 3.39958 6.1142C3.38504 6.05075 3.38504 5.95069 3.39958 5.88725C3.41894 5.80278 3.45353 5.74801 3.5227 5.63849C4.09431 4.73339 5.79576 2.44531 8.38867 2.44531C10.9816 2.44531 12.683 4.73339 13.2546 5.63849C13.3238 5.74801 13.3584 5.80278 13.3778 5.88725C13.3923 5.95069 13.3923 6.05075 13.3778 6.1142C13.3584 6.19867 13.3238 6.25343 13.2546 6.36296C12.683 7.26805 10.9816 9.55613 8.38867 9.55613C5.79576 9.55613 4.09431 7.26805 3.5227 6.36296Z"
            stroke="#FCFCFD"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.38867 7.52447C9.23021 7.52447 9.91242 6.84226 9.91242 6.00072C9.91242 5.15918 9.23021 4.47698 8.38867 4.47698C7.54713 4.47698 6.86492 5.15918 6.86492 6.00072C6.86492 6.84226 7.54713 7.52447 8.38867 7.52447Z"
            stroke="#FCFCFD"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "stop-button":
      return (
        <svg
          width={width || "17"}
          height={height || "16"}
          className={className}
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 5.2C2.5 4.0799 2.5 3.51984 2.71799 3.09202C2.90973 2.71569 3.21569 2.40973 3.59202 2.21799C4.01984 2 4.5799 2 5.7 2H11.3C12.4201 2 12.9802 2 13.408 2.21799C13.7843 2.40973 14.0903 2.71569 14.282 3.09202C14.5 3.51984 14.5 4.0799 14.5 5.2V10.8C14.5 11.9201 14.5 12.4802 14.282 12.908C14.0903 13.2843 13.7843 13.5903 13.408 13.782C12.9802 14 12.4201 14 11.3 14H5.7C4.5799 14 4.01984 14 3.59202 13.782C3.21569 13.5903 2.90973 13.2843 2.71799 12.908C2.5 12.4802 2.5 11.9201 2.5 10.8V5.2Z"
            fill="#FCFCFD"
            stroke="#FCFCFD"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "start-button":
      return (
        <svg
          width={width || "17"}
          height={height || "16"}
          className={className}
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.8335 3.32764C3.8335 2.6802 3.8335 2.35648 3.96849 2.17803C4.08609 2.02257 4.26584 1.92637 4.46043 1.91475C4.68379 1.90142 4.95314 2.08099 5.49184 2.44012L12.5022 7.11371C12.9473 7.41045 13.1699 7.55883 13.2475 7.74585C13.3153 7.90935 13.3153 8.0931 13.2475 8.25661C13.1699 8.44362 12.9473 8.592 12.5022 8.88875L5.49184 13.5623C4.95314 13.9215 4.68379 14.101 4.46043 14.0877C4.26584 14.0761 4.08609 13.9799 3.96849 13.8244C3.8335 13.646 3.8335 13.3223 3.8335 12.6748V3.32764Z"
            fill="#FCFCFD"
            stroke="#FCFCFD"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "help-icon":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || "21"}
          height={height || "21"}
          viewBox="0 0 24 24"
          fill="none"
          stroke={color || "#FCFCFD"}
          stroke-width={strokeWidth || "1.8"}
          stroke-linecap="round"
          stroke-linejoin="round"
          className="lucide lucide-circle-help"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <path d="M12 17h.01" />
        </svg>
      );
    case "warning-icon":
      return (
        <svg
          width={width || "48"}
          height={height || "49"}
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 24.5C0 11.2452 10.7452 0.5 24 0.5C37.2548 0.5 48 11.2452 48 24.5C48 37.7548 37.2548 48.5 24 48.5C10.7452 48.5 0 37.7548 0 24.5Z"
            fill="#FEE4E2"
          />
          <path
            d="M23.9998 20.9963V24.9963M23.9998 28.9963H24.0098M22.6151 15.888L14.3902 30.0947C13.934 30.8827 13.7059 31.2767 13.7396 31.6C13.769 31.8821 13.9168 32.1384 14.1461 32.3051C14.4091 32.4963 14.8643 32.4963 15.7749 32.4963H32.2246C33.1352 32.4963 33.5904 32.4963 33.8534 32.3051C34.0827 32.1384 34.2305 31.8821 34.2599 31.6C34.2936 31.2767 34.0655 30.8827 33.6093 30.0947L25.3844 15.888C24.9299 15.1029 24.7026 14.7103 24.4061 14.5784C24.1474 14.4634 23.8521 14.4634 23.5935 14.5784C23.2969 14.7103 23.0696 15.1029 22.6151 15.888Z"
            stroke="#D92D20"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "mic-icon":
      return (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
            fill="#EAF3FE"
          />
          <path
            d="M31 22V24C31 27.866 27.866 31 24 31M17 22V24C17 27.866 20.134 31 24 31M24 31V34M20 34H28M24 27C22.3431 27 21 25.6569 21 24V17C21 15.3431 22.3431 14 24 14C25.6569 14 27 15.3431 27 17V24C27 25.6569 25.6569 27 24 27Z"
            stroke="#206DC5"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );

    default:
      break;
  }
}
export default Icon;
